import React from "react";
import PdfViewer from "../../PdfViewer";

const SoporteClienteTotal = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/07-soporte-a-cliente-total.pdf`;
  /*const pdfUrl = "/pdf/07-soporte-a-cliente-total.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Soporte a Cliente Total</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default SoporteClienteTotal;
